module.exports = __webpack_public_path__ + "static/media/thumb-down-line.3b9e3c93.svg";